import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { RouterModule, ROUTES } from '@angular/router';
import { AppPreloadStrategy } from '../app/app-preload-strategy';
import { routeFactory } from './route-factory';
import { ExperimentsService } from '../app/shared/services/experiments/experiments.service';
import { ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';

@NgModule({
  imports: [
    RouterModule.forRoot([], { preloadingStrategy: AppPreloadStrategy }),
  ],
  exports: [RouterModule],
  providers: [
    AppPreloadStrategy,
    ExperimentsService,
    {
      provide: ROUTES,
      multi: true,
      useFactory: routeFactory,
      deps: [ExperimentsService],
      useValue: {},
    },
    {
      provide: ANALYZE_FOR_ENTRY_COMPONENTS,
      useValue: [],
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppDesktopRoutingModule {
  constructor() {}
}
